import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Saasclientreview() {
  return (
    <section className="saas_client_review tekrevol_dark_bg p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>
              Client <span>Testimonials</span>
            </h2>
            <p>
              Tekrevol has the team of the best techies, and highly versatile
              creatives who can help you to:
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="client_review_box">
              <div className="client_upper">
                <h5>Padraig Conaty</h5>
                <span>Founder of ClubSpot</span>
              </div>
              <p>
                “We recently had the pleasure of working with Tekrevol on a
                project where we wanted to make an animated intro to put across
                our social media. From the get go, the entire team were
                incredibly helpful. They were informative, and brilliant
                throughout the project.”
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="client_review_box">
              <div className="client_upper">
                <h5>Steven Burns</h5>
                <span>Owner of Starviz</span>
              </div>
              <p>
                "They created an absolute gem of a video. Great quality! Amazing
                scripting that made our message to all of our new employees
                exceptionally clear.”
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="client_review_box">
              <div className="client_upper">
                <h5>Dominic Vicencio</h5>
                <span>Marketing Manager SwellSpace</span>
              </div>
              <p>
                “They would even meet me over the weekend, if I was available.
                That meant a lot to ensure that timelines were met. The
                experience was really good. I felt like I was working with my
                own creative team.”
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Saasclientreview;
